<mat-card appearance="outlined"  [formGroup]="kostenstelleForm">
  <mat-card-content class="no-title">
    <span class="row">
      <mat-form-field>
        <mat-label>{{ "HOME.Kostenstelle" | translate }}</mat-label>
        <mat-select formControlName="kostenStelle" (selectionChange)="kostenstelleChange($event.value)">
          <mat-option *ngFor="let item of kostenStelleModel" [value]="item.costCenterID">
            {{ item.costCenterID }} {{ item.description }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </span>
    <span class="row">
      <mat-form-field>
        <mat-label> {{ "HOME.Arbeitsort" | translate }} </mat-label>

        <input matInput placeholder="{{ 'HOME.Arbeitsort' | translate }}" formControlName="arbeitsOrt" />
      </mat-form-field>
      <mat-icon *ngIf="!userPermissions?.noDataEditOnHandy" (click)="setLocation()">pin_drop</mat-icon>

    </span>
    <span class="row" *ngIf="userPermissions?.workPlaceWithAdress">
      <mat-form-field>
        <mat-label>{{ "HOME.Straße" | translate }} </mat-label>
        <input matInput placeholder="{{ 'HOME.Straße' | translate }}" formControlName="strasse" />
      </mat-form-field>
    </span>
    <span class="row">
      <mat-form-field>
        <mat-label> {{ "HOME.Text" | translate }} </mat-label>
        <input matInput placeholder="{{ 'HOME.Text' | translate }}" formControlName="text" maxlength="250" />
      </mat-form-field>
    </span>

  </mat-card-content>

  <mat-dialog-actions>
	  <button (click)="next()" [disabled]="!kostenstelleForm.valid" [innerText]="'MAIN_APP_DIALOG.INPUT_DIALOG.save' | translate" class="confirm" mat-stroked-button></button>
    <button mat-stroked-button class="cancel" (click)="closeDialog()" [innerText] = "'MAIN_APP_DIALOG.INPUT_DIALOG.cancel' | translate"></button>
  </mat-dialog-actions>
</mat-card>
